module.exports = __webpack_public_path__ + "img/schedule.75c83217.svg";